<script setup lang="ts">
const props = defineProps<{
    value: string;
    color: string;
}>();
</script>

<template>
    <div class="d-flex align-center ga-1" v-if="value">
        <div :style="'background: ' + props.color" class="rounded-xl" style="padding: 5px"></div>
        {{ props.value }}
    </div>
    <div v-else>-</div>
</template>

<style scoped></style>
